











import { Vue, Component, Prop } from 'vue-property-decorator'

@Component({})
export default class Field extends Vue {
  @Prop({ type: String }) label: any

  @Prop({ type: Boolean, default: false }) required: any
}
